/* eslint-disable react/prop-types */
import React from "react";

import styled from "styled-components";

import { Button } from "ds/Button";

import { calcColumnWidth } from "../utils/layout";

const DefaultButton = styled(Button)`
  width: ${props =>
    props.width || `calc(${calcColumnWidth(3, 6, "end", true)} - 16px)`};
  max-width: 350px;
  padding: 0;

  &::first-letter {
    text-transform: uppercase;
  }

  @media only screen and (max-width: 940px) {
    max-width: 500px;
    width: ${props => props.width || calcColumnWidth(3, 6, "end", true)};
  }
`;

const ButtonComponent = props => {
  let Button = DefaultButton;

  return (
    <Button
      disabled={props.isLoading || props.disabled}
      {...props}
      analyticId={props.text}
    >
      {props.text || props.children}
    </Button>
  );
};

export default ButtonComponent;
